<template id="form_section">
  <div class="franchise-wrapper">
    <!-- New Design -->
    <section class="container-fluid pb-xl-5 mb-5 mx-lg-3">
      <div class="row align-items-start justify-content-center">
        <div class="col-lg-6 custom_overflow mr-2">
          <!-- custom_background_image -->
          <h3 class="main-heading-1-gradient" data-aos="fade-right" data-aos-duration="600">Welcome To The Pune Office
          </h3>
          <h3 class="main-heading-1-gradient" data-aos="fade-left" data-aos-duration="600">
            पुणे कार्यालयात आपले स्वागत आहे</h3>
          <!-- <p class="main-content-1 pt-1 fontWeightCustom">
            Applying to the Aliff Than Office is a breeze - just fill in the
            necessary details and submit the form! Below, you'll find helpful
            information to determine if this office is right fit for you. Don't
            worry about scrolling all the way back up, there's a button at the
            end that takes you straight to the form!
          </p> -->
          <p class="main-content-1 pt-1 fontWeightCustom mb-0">
            <img src="@/assets/imgs/franchise/Poniter.svg" />
            St Crispin's Home, Second floor , Left Wing, Near Nal Stop Chowk,
            Karve road , Pune-411004
          </p>

          <p class="main-content-1 pt-1 fontWeightCustom mb-0">
            <img src="@/assets/imgs/franchise/Phone.svg" />
            <a href="tel:+91 8655244122" style="color: #212529">+91 8655244122</a>
          </p>

          <p class="main-content-1 pt-1 fontWeightCustom mb-0">
            <img src="@/assets/imgs/franchise/email_2099199.svg" />
            <a href="mailto:rutvij@aliff.in" style="color: #212529">rutvij@aliff.in</a>
          </p>

          <div class="text-right city_img">
            <img src="@/assets/imgs/city.png" alt="" />
          </div>
        </div>

        <div class="col-lg-5 form_wrapper responsive_margin" data-aos="fade-up" data-aos-duration="600"
          style="border-radius: 10px">
          <form @submit.prevent="handleSubmit">
            <div class="custom-form-control">
              <div class="form-spacing">
                <label>Name:</label>
                <input size="sm" required v-model="form.name" placeholder="Enter Name *" class="form-control" />
              </div>

              <div class="form-spacing">
                <label>Email:</label>
                <input required size="sm" v-model="form.email" placeholder="Enter Email Address *"
                  class="form-control" />
              </div>

              <div class="form-spacing">
                <label>Phone Number:</label>
                <input required size="sm" v-model="form.mobileNumber" placeholder="Enter Mobile Number *"
                  class="form-control" />
              </div>

              <label>Select State:</label>

              <b-form-select required size="sm" v-model="form.state" :options="stateOptions"
                class="form-control"></b-form-select>

              <label>Select City:</label>

              <b-form-select required size="sm" v-model="form.city" :options="cityOptions"
                class="form-control"></b-form-select>

              <div class="w-100 pt-4 pb-3 d-flex justify-content-start">
                <button type="submit" class="btn rounded w-50" style="background-color: #fe6d01; color: white">
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>

    <section class="container-fluid px-5 pb-xl-5 mb-5 destinations-section section-spacing">
      <h2 class="main-heading-1-gradient text-center" data-aos="fade-down" data-aos-duration="600">Explore multiple
        countries for your education</h2>
      <div class="col-lg-12 pt-xl-5 mt-3">
        <slick ref="destinationSlider" :options="destinationSlider" class="destination-slider arrow-slider px-lg-5"
          v-if="getCountries.length > 0">
          <div data-aos="zoom-in" v-for="(country, index) in getCountries" :key="'country_cards_' + index"
            class="dest-card">
            <div class="dest-img">
              <img v-if="country.country_image" :src="country.country_image" class="img-fluid" />
              <img v-else src="@/assets/imgs/dest.png" class="img-fluid" />
            </div>
            <div class="dest-content py-2">
              <h4 class="">Study in {{ country.country_name }}</h4>
            </div>
          </div>
          <div data-aos="zoom-in" v-for="(country, index) in getCountries" :key="'country_cards_' + index"
            class="dest-card">
            <div class="dest-img">
              <img v-if="country.country_image" :src="country.country_image" class="img-fluid" />
              <img v-else src="@/assets/imgs/dest.png" class="img-fluid" />
            </div>
            <div class="dest-content py-2">
              <h4 class="">Study in {{ country.country_name }}</h4>
            </div>
          </div>
        </slick>
      </div>
    </section>

    <!-- Expand Your Horizons-->
    <section class="university-section section-spacing home-page">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-lg-12 text-center" data-aos="fade-down" data-aos-duration="600">
            <h2 class="main-heading-1-gradient text-center">
              Discover and choose from a variety of universities
            </h2>
          </div>
          <div class="col-lg-12 mt-3 pt-xl-5">
            <slick ref="logoSlider" :options="logoSlider" class="logo-slider" v-if="featured_universities.length > 0">
              <div v-for="(university, index) in featured_universities" :key="'featured_universities_' + index">
                <div class="logo-card">
                  <div class="logo-img">
                    <img :src="IMAGEURL + university[0].university_logo" class="img-fluid" />
                  </div>
                </div>
                <div class="logo-card">
                  <div class="logo-img">
                    <img :src="IMAGEURL + university[1].university_logo" class="img-fluid" />
                  </div>
                </div>
                <div class="logo-card">
                  <div class="logo-img">
                    <img :src="IMAGEURL + university[2].university_logo" class="img-fluid" />
                  </div>
                </div>
              </div>
            </slick>
          </div>
        </div>
      </div>
    </section>

    <section class="container-fluid pb-xl-5 mb-5 responsive_padding">
      <h2 class="main-heading-1-gradient text-center mb-5" data-aos="fade-down" data-aos-duration="600">
        Why Choose Aliff Pune
      </h2>
      <div class="row gradient-box bg-primary-gradient">
        <div class="col-md-6 col-lg-4 text-center mb-5">
          <!-- <animated-number
            :value="establishedvalue"
            :duration="3000"
            class="numbers_class"
          /> -->
          <img src="@/assets/imgs/franchise/established.png" class="icons_custom" />
          <p class="numbers_class">2008</p>
          <!-- /*:formatValue="formatToPrice"*/ -->
          <p class="sub_heading_text">Established</p>
        </div>

        <div class="col-md-6 col-lg-4 text-center mb-5">
          <!-- <animated-number
            :value="studentValue"
            :duration="3000"
            class="numbers_class"
            :formatValue="formatToPrice"
          /> -->
          <img src="@/assets/imgs/franchise/studentCoun.png" class="icons_custom" />
          <p class="numbers_class">23K+</p>
          <p class="sub_heading_text">Students Counselled</p>
        </div>

        <div class="col-md-6 col-lg-4 text-center mb-5">
          <img src="@/assets/imgs/franchise/Scholarships.png" class="icons_custom" />
          <p class="numbers_class">&#8377; 28 Crore+</p>
          <p class="sub_heading_text">Scholarships awarded</p>
        </div>

        <div class="col-md-6 col-lg-4 text-center">
          <img src="@/assets/imgs/franchise/university_4981427.png" class="icons_custom" />
          <p class="numbers_class">500+</p>
          <p class="sub_heading_text">Universities</p>
        </div>

        <div class="col-md-6 col-lg-4 text-center">
          <img src="@/assets/imgs/franchise/bachelor_8019886.png" class="icons_custom" />
          <p class="numbers_class">100%</p>
          <p class="sub_heading_text">Admission Success</p>
        </div>

        <div class="col-md-6 col-lg-4 text-center">
          <img src="@/assets/imgs/franchise/navigation_2763373.png" class="icons_custom" />
          <p class="numbers_class">14+</p>
          <p class="sub_heading_text">Countries</p>
        </div>
      </div>
    </section>

    <section class="student-section py-xl-5 my-5">
      <div class="container-fluid bg-row py-5">
        <div class="row justify-content-center">
          <div class="col-lg-6 text-center">
            <div class="main-heading-1"> What Our Students Say </div>
            <!-- <div class="main-content-1">
              Ascend higher without the financial weight. Our customized prices
              give you the edge you need.
            </div> -->
          </div>
          <div class="col-lg-12 mt-5 stu-card-section">
            <FranchiseTestimonialSlider :testimonialsData="testimonialData['career-counselling']['testimonial-1']
              " />
          </div>
        </div>
      </div>
    </section>

    <section class="founder-section pb-xl-5 mb-5">
      <!-- background_image_section -->

      <div class="container-fluid responsive_padding">
        <h2 class="main-heading-1-gradient text-center" data-aos="fade-down" data-aos-duration="600">
          About Area Director
        </h2>

        <div class="row mt-5 align-items-start custom_director_section">
          <div class="col-md-6 col-lg-3 responsive-img text-right" data-aos="fade-down" data-aos-duration="600">
            <img src="@/assets/imgs/aslam-founder.png" class="img-fluid border-20 custom_width_image" />
            <!-- <img
              src="@/assets/imgs/franchise/1.png"
              class="img-fluid border-20 custom_width_image"
            /> -->
          </div>
          <div class="col-md-6 col-lg-3 text-left" data-aos="fade-up" data-aos-duration="600">
            <h1 class="font-weight-bold responsive_margin_area">Rutvij Jadhav</h1>
            <h5 class="new_sub_heading_color pt-2 font-weight-bold">Background</h5>
            <p class="main-content-1 pt-2">
              Worked as Production and Supply Chain Planner for Colortrend,
              Australian Paint manufacturing company. Alumni for Deakin
              University Australia
            </p>

            <!-- <h5 class="new_sub_heading_color pt-2 font-weight-bold"
              >Current Affairs</h5
            >
            <p class="main-content-1 pt-2"> AVP - DAM capital </p> -->

            <h5 class="new_sub_heading_color pt-2 font-weight-bold">Location</h5>
            <p class="main-content-1 pt-2"> Deccan , Pune , India </p>
            <!-- <img
              src="@/assets/imgs/franchise/Group18259.png"
              class="director_background"
            /> -->
          </div>

          <hr class="mob_hr horizontal_line my-4" />

          <div class="col-md-6 col-lg-3 responsive-img text-right" data-aos="fade-up" data-aos-duration="600">
            <!-- <img
              src="@/assets/imgs/aslam-founder.png"
              class="img-fluid border-20"
            /> -->
            <img src="@/assets/imgs/franchise/1.png" class="img-fluid border-20" />
          </div>

          <div class="col-md-6 col-lg-3 text-left" data-aos="fade-down" data-aos-duration="600">
            <h1 class="font-weight-bold responsive_margin_area">Sudeshna B</h1>
            <h5 class="new_sub_heading_color pt-2 font-weight-bold">Background</h5>
            <p class="main-content-1 pt-2">
              7 years work experience as test prep teacher
            </p>
            <!--
            <h5 class="new_sub_heading_color pt-2 font-weight-bold"
              >Current Affairs</h5
            >
            <p class="main-content-1 pt-2"> Adentech- Advertising agency </p> -->

            <h5 class="new_sub_heading_color pt-2 font-weight-bold">Location</h5>
            <p class="main-content-1 pt-2"> Pimple Saudagar , Pune , India </p>
            <!-- <img
              src="@/assets/imgs/franchise/Group18259.png"
              class="director_background"
            /> -->
          </div>

          <hr class="mob_hr horizontal_line my-4" />

          <div class="col-md-6 col-lg-3 responsive-img text-right custom_franc_director_margin" data-aos="fade-up"
            data-aos-duration="600">
            <img src="@/assets/imgs/aslam-founder.png" class="img-fluid border-20" />
            <!-- <img
              src="@/assets/imgs/franchise/1.png"
              class="img-fluid border-20"
            /> -->
          </div>

          <div class="col-md-6 col-lg-3 text-left custom_franc_director_margin" data-aos="fade-down"
            data-aos-duration="600">
            <h1 class="font-weight-bold responsive_margin_area">Sandeep Dravid</h1>
            <h5 class="new_sub_heading_color pt-2 font-weight-bold">Background</h5>
            <p class="main-content-1 pt-2"> Seicco ( In Overseas Company ) </p>

            <!-- <h5 class="new_sub_heading_color pt-2 font-weight-bold"
              >Current Affairs</h5
            >
            <p class="main-content-1 pt-2"> Adentech- Advertising agency </p> -->

            <h5 class="new_sub_heading_color pt-2 font-weight-bold">Location</h5>
            <p class="main-content-1 pt-2"> Karve road , Pune , India </p>
            <!-- <img
              src="@/assets/imgs/franchise/Group18259.png"
              class="director_background"
            /> -->
          </div>
        </div>
      </div>
    </section>

    <section class="container-fluid pb-xl-5 responsive_padding">
      <h2 class="main-heading-1-gradient text-center mb-5" data-aos="fade-down" data-aos-duration="600">
        Photographs
      </h2>
      <div class="team-member-cards">
        <slick ref="teamIntroSlider" :options="teamIntroSlider"
          class="stu-card-slider green-slick-dots franchise-card-slider">
          <img src="@/assets/imgs/franchise/Baroda/Baroda_office_image_1.jpeg" />
          <img src="@/assets/imgs/franchise/Baroda/Baroda_office_image_2.jpeg" />
          <img src="@/assets/imgs/franchise/Baroda/Baroda_office_image_3.jpeg" />
          <img src="@/assets/imgs/franchise/Baroda/Baroda_office_image_4.jpeg" />
        </slick>
      </div>
    </section>

    <hr class="horizontal_line py-xl-1 mb-5" data-aos="fade-down" data-aos-duration="600" />

    <section class="container">
      <div class="row">
        <div class="col-12 mb-5">
          <div class="d-flex align-items-center justify-content-center">
            <!-- <img
              title="my-img"
              src="@/assets/imgs/student-enquiry-form/AliffLogo.png"
              alt="people"
              class="free-counselling-logo-new"
            /> -->
            <h2>Book Free Counselling</h2>
          </div>
          <p>
            Go doubt-free in your study abroad journey by connecting with our
            experts!
          </p>
          <div class="mt-3">Schedule a free call and get:</div>
          <ul>
            <li>Your profile evaluated.</li>
            <li>Country, university and course guidance.</li>
            <li>Scholarship and loan assistance.</li>
          </ul>
          <a href="#form_section" class="w-100 text-center">
            <button class="btn-secondary-red mt-4 w-100">
              Schedule Call
            </button>
          </a>
          <!-- <div class="w-100 d-flex justify-content-center">
            <a href="#form_section" class="w-50 text-center">
              <button class="main_btn_custom"
                >Book Your Free Counseling Today</button
              >
            </a>
          </div> -->
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import FranchiseTestimonialSlider from "@/components/partials/FranchiseTestimonial.vue";
import homeServices from "@/apiServices/homeServices";
import { mapGetters } from "vuex";
import AnimatedNumber from "animated-number-vue";
import { IMAGEURL } from "@/config";
import {
  stateOptions,
  courseOptions,
  specializationOptions,
  cityOptions,
} from "../partials/sefDetails";
export default {
  components: {
    FranchiseTestimonialSlider,
    AnimatedNumber,
  },
  data() {
    return {
      IMAGEURL,
      establishedvalue: 2008,
      studentValue: 23,
      featured_universities: [],
      logoSlider: {
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 1000,
        speed: 3000,
        pauseOnHover: true,
        cssEase: "linear",
        centerMode: true,
        centerPadding: "30px",
        adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ],
      },
      teamIntroSlider: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        // cssEase: "linear",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },

      stateOptions,
      courseOptions,
      specializationOptions,
      cityOptions,
      form: {
        name: "",
        email: "",
        mobileNumber: "",
        state: null,
        city: null,
      },
      destinationSlider: {
        infinite: true,
        rows: 2,
        slidesPerRow: 1,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 1000,
        cssEase: "ease",
        useTransform: true,
        speed: 1000,
        cssEase: "linear",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
              arrows: false,
              dots: true,
            },
          },
        ],
      },
    };
  },
  props: {
    testimonialsData: {
      type: Array,
      default: "",
    },
  },
  beforeMount() {
    this.getData();
  },
  computed: {
    ...mapGetters(["getCountries"]),
  },
  methods: {
    // formatToPrice(studentValue) {
    //   return `${studentValue}K+`;
    // },
    formSubmitToast() {
      this.$bvToast.toast(`The form has been submitted successfully.`, {
        title: "Form Submitted",
        autoHideDelay: 5000,
        solid: true,
      });
    },

    async handleSubmit(e) {
      try {
        e.preventDefault();

        const requestData = {
          name: this.form.name,
          email: this.form.email,
          dial_code_id: "12183",
          country_dial_code: "+91",
          mobile: this.form.mobileNumber,
          source: "associate-enquiry-form",
          state: this.form.state,
          city: this.form.city,
        };

        // const response = await axios.post(
        //   "https://api.nopaperforms.io/lead/v1/create",
        //   requestData
        // );
        const response = await homeServices.saveSef(requestData);

        if (response.data.status) {
          this.resetForm();
          this.formSubmitToast();
        }

        console.log("API Response:", response.data);
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },

    resetForm() {
      this.form = {
        name: "",
        email: "",
        mobileNumber: "",
        state: null,
        city: null,
      };
    },
    async getData() {
      try {
        const featured_universities =
          await homeServices.getFeaturedUniversities();
        if (featured_universities.data.status) {
          const data = featured_universities.data.data;
          let temp_arr = [];
          let i = 0;
          while (i < data.length) {
            let arr = [];
            arr.push(data[i]);
            arr.push(data[i + 1]);
            arr.push(data[i + 2]);
            temp_arr.push(arr);
            i = i + 3;
          }
          this.featured_universities = temp_arr;
        }
      } catch (err) {
        console.log("Error in getting data ", err);
      }
    },
  },
};
</script>
<style>
.franchise-wrapper {
  margin-top: 120px;
}

.form_wrapper {
  padding: 20px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.fontWeightCustom {
  font-weight: 500;
}

.horizontal_line {
  width: 100%;
}

.city_img {
  position: absolute;
  top: 190px;
  right: 20px;
  z-index: -1;
  opacity: 0.2;
}

.city_img img {
  width: 90%;
}

.numbers_class {
  font-size: 30px;
  font-weight: bold;
}

.sub_heading_text {
  font-size: 30px;
}

.icons_custom {
  width: 25%;
  filter: drop-shadow(0 0 0.75rem black);
  margin-bottom: 10px;
}

.director_background {
  position: absolute;
  right: 0;
  top: 100px;
  opacity: 0.2;
  z-index: -1;
}

.custom_director_section {
  padding: 40px;
  background: #eaf4fe;
  border-radius: 10px;
  box-shadow: 0px 0px 0.806476px rgba(12, 26, 75, 0.1),
    3.22591px 4.83886px 12.9036px rgba(20, 37, 63, 0.12);
}

.responsive_padding {
  padding: 0 3rem;
}

.new_sub_heading_color {
  color: #ff3d00 !important;
}

.mob_hr {
  display: none;
}

.custom_franc_director_margin {
  margin-top: 50px;
}

@media (max-width: 767px) {
  .custom_franc_director_margin {
    margin-top: 0px;
  }

  .responsive_margin {
    margin-top: 20px;
  }

  .responsive_margin_area {
    margin-top: 30px;
  }

  .main_btn_custom {
    width: 100%;
    transform: scale(1) !important;
  }

  .director_background {
    position: absolute;
    top: 15px;
    opacity: 0.1;
    z-index: -1;
    widows: 100%;
    right: -133px;
  }

  .responsive_padding {
    padding: 0px;
  }

  .custom_overflow {
    overflow: hidden;
  }

  .city_img {
    position: absolute;
    top: 44%;
    right: -30%;
    z-index: -1;
    opacity: 0.2;
    /* width: 100%; */
  }

  .mob_hr {
    display: block;
  }

  .mob_custom_padding {
    padding-bottom: 10px !important;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .custom_overflow {
    overflow: hidden;
  }

  .responsive_margin {
    margin-top: 10px;
  }

  .city_img {
    position: absolute;
    top: -15%;
    right: -30%;
    opacity: 0.2;
    width: 100%;
  }

  .director_background {
    position: absolute;
    right: 0;
    top: 0px;
    opacity: 0.1;
  }

  .icons_custom {
    width: 40%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/PuneFranchisePage.vue